import React from 'react';
import { Link } from '@tanstack/react-router';
import pluralize from 'pluralize';

import type { ContributorInvitation } from '../../types/contributor-invitation';

type DashboardInvitationProps = {
  invitation: ContributorInvitation;
  disabled: boolean;
  acceptInvitation: (invitation: ContributorInvitation) => Promise<void>;
  declineInvitation: (invitation: ContributorInvitation) => Promise<void>;
};

const DashboardInvitation: React.FC<DashboardInvitationProps> = ({ invitation, disabled, acceptInvitation, declineInvitation }) => {
  return (
    <wa-card>
      <div className="wa-cluster wa-gap-2xs dashboard-invitation">
        <div className="dashboard-invitation-timeline">
          <Link to={`/timelines/${invitation.timeline.id}`} target="_blank">
            {invitation.timeline.dedicated_to}
          </Link>
          <div className="dashboard-invitation-timeline-title">
            Created by {invitation.timeline.user.name} · {invitation.timeline.memories.length} {pluralize('memory', invitation.timeline.memories.length)}
          </div>
        </div>
        <div className="dashboard-invitation-actions wa-cluster wa-gap-2xs">
          <wa-button href={`/timelines/${invitation.timeline.id}`} size="xs" target="_blank">
            View Timeline
          </wa-button>
          <wa-button size="xs" onClick={() => acceptInvitation(invitation)} disabled={disabled}>
            Accept
          </wa-button>
          <wa-button size="xs" onClick={() => declineInvitation(invitation)} disabled={disabled}>
            Decline
          </wa-button>
        </div>
      </div>
    </wa-card>
  );
}

export default DashboardInvitation;
